import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import Cookie from "js-cookie";

import { asyncRouterMap, constantRouterMap } from "@/router";
import * as utils from "@/utils";

NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf("admin") >= 0) return true; // admin permission passed directly
  if (!permissionRoles) return true;
  return roles.some(role => permissionRoles.indexOf(role) >= 0);
}

const whiteList = ["/login", "/auth-redirect", "/white", "/white-device", "/jytQueueScreen"]; // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  let userRoles = window.localStorage.userRoles;

  console.log("to.path", to.path);

  if (to.path == "/white") {
    let token = to.query.token.replace("#wechat_redirect", "");
    token = decodeURIComponent(token);
    // alert("里边的" + token);
    window.localStorage.Token = token;
  }

  if (window.localStorage.Token && userRoles && window.localStorage.userId) {
    if (to.path === "/login") {
      next({
        path: "/"
      });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.addRouters.length == 0) {
        // 全部页面
        // let accessedRouters = asyncRouterMap.concat(constantRouterMap)
        // store.commit('SET_ROLES', ['admin'])
        // store.commit('SET_ROUTERS', asyncRouterMap)
        // router.addRoutes(accessedRouters) // 动态添加可访问路由表
        // next({ ...to, replace: true })

        // 根据权限返回路由表
        let roles = JSON.parse(decodeURI(userRoles));
        store
          .dispatch("GenerateRoutes", {
            roles
          })
          .then(() => {
            // 根据roles权限生成可访问的路由表
            // console.log('store.getters.addRouters', store.getters.addRouters)
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({
              ...to,
              replace: true
            }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          });
      } else {
        next();
      }

      // -- 业务协同添加气泡
      setTimeout(() => {
        utils.setBubble();
      }, 1000)

      // -- 车辆冒泡
      console.log("----", to.path);
      if (to.path.indexOf("/vehicleMan") >= 0) {
        utils.setCarNavMp();
      }

      // -- 最近访问
      let zjfwLocalData;
      if (!window.localStorage.zjfwLocalData) {
        zjfwLocalData = [];
      } else {
        zjfwLocalData = JSON.parse(window.localStorage.zjfwLocalData);
      }
      // 是否存在
      let isHas = false;
      for (let item of zjfwLocalData) {
        if (item.name == to.name) {
          isHas = true;
          break;
        }
      }
      if (!isHas && to.path != "/dashboard" && to.name != null) {
        let obj = {
          name: to.name,
          path: to.path,

        };
        var pattern2 = new RegExp("[A-Za-z]+");

        if (pattern2.test(to.name)) {
          obj.name = to.meta.title
        }

        zjfwLocalData.unshift(obj);
        if (zjfwLocalData.length > 10) {
          zjfwLocalData.pop();
        }
        console.log("zjfwLocalData", JSON.stringify(zjfwLocalData));
        window.localStorage.zjfwLocalData = JSON.stringify(zjfwLocalData);
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      Message({
        type: "warning",
        message: "登录超时，请您重新登录"
      });
      next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
      NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});

// 路由错误捕获
router.onError((error, to, from) => {
  // alert("error:" + error);
  // error:TypeError: Cannot read properties of undefined (reading 'replace')
  NProgress.done(); // finish progress bar
  console.log("----路由报错");
  console.log("error", error);
  console.log("to", to);
  console.log("from", from);
  Message.warning("系统已升级，请【刷新浏览器】重试");
});
